/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Metric_YearsInputs */

const en_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Years shipping`)
};

const ar_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنوات من الإنتاج`)
};

const bn_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বছরের অভিজ্ঞতা`)
};

const de_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahre Versand`)
};

const es_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Años de envío`)
};

const fr_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ans d'expédition`)
};

const pt_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anos de envio`)
};

const zh_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年运输`)
};

const tr_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıl gönderimi`)
};

const ru_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Годы доставки`)
};

const pl_cta_metric_years = /** @type {(inputs: Cta_Metric_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lata wysyłki`)
};

/**
* | output |
* | --- |
* | "Years shipping" |
*
* @param {Cta_Metric_YearsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_metric_years = /** @type {((inputs?: Cta_Metric_YearsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Metric_YearsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_metric_years(inputs)
	if (locale === "bn") return bn_cta_metric_years(inputs)
	if (locale === "de") return de_cta_metric_years(inputs)
	if (locale === "es") return es_cta_metric_years(inputs)
	if (locale === "fr") return fr_cta_metric_years(inputs)
	if (locale === "pt") return pt_cta_metric_years(inputs)
	if (locale === "zh") return zh_cta_metric_years(inputs)
	if (locale === "tr") return tr_cta_metric_years(inputs)
	if (locale === "ru") return ru_cta_metric_years(inputs)
	if (locale === "pl") return pl_cta_metric_years(inputs)
	return en_cta_metric_years(inputs)
});